import { Map } from 'immutable'

export function keyBy(elements, opts) {
  const { acc = Map(), keyGetter = (element) => element.get('id') } = opts || {}
  return acc.withMutations(state => {
    elements.forEach(element => state.set(keyGetter(element), element))
  })
}



// WEBPACK FOOTER //
// ./src/scripts/utils/immutable.js